import { useRegionalSettings } from '@context/regionalSettings';

const DEFAULT_LOCALE_ENGLISH_US = 'en-US';

type FormattedDateProps = {
  readonly value: Date | string | null;
  readonly locale?: string;
  readonly showTime?: boolean;
  readonly options?: Intl.DateTimeFormatOptions;
  readonly isUTC?: boolean;
};

export default function FormattedDate({
  value,
  locale: propLocale,
  showTime = false,
  options: propOptions,
  isUTC = false,
}: FormattedDateProps) {
  const { locale: contextLocale } = useRegionalSettings();

  const locale = propLocale || contextLocale || DEFAULT_LOCALE_ENGLISH_US;
  const options = propOptions || {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: showTime ? '2-digit' : undefined,
    minute: showTime ? '2-digit' : undefined,
    second: showTime ? '2-digit' : undefined,
  };

  if (!value) return null;

  let parsedDate: Date;
  if (typeof value === 'string') {
    if (
      value === 'N/A' ||
      value === 'null' ||
      value === 'undefined' ||
      value.trim() === ''
    ) {
      return null;
    }

    if (isUTC) {
      if (
        value.includes('Z') ||
        value.includes('+') ||
        value.includes('-', 10)
      ) {
        parsedDate = new Date(value);
      } else {
        parsedDate = new Date(value + 'Z');
      }
    } else {
      parsedDate = new Date(value);
    }
  } else {
    parsedDate = value;
  }

  if (isNaN(parsedDate.getTime())) {
    return null;
  }

  const formatOptions: Intl.DateTimeFormatOptions = {
    ...options,
  };

  const formattedDate = new Intl.DateTimeFormat(
    [locale, DEFAULT_LOCALE_ENGLISH_US],
    formatOptions
  ).format(parsedDate);

  return <span>{formattedDate}</span>;
}
